export default "__VITE_ASSET__f4fbac5b__"